import React from "react";
import Card from 'Components/DesignSystem/Card/Card';
import {
    HelpTextData,
    TConnector,
    TField,
    TIndexState,
    TProductCategory,
    TSubmodel,
    TUpsertISRProjectDataModelsInput
} from '../Pages/DefineModel/model';
import AppSettings from "../../../../Settings/AppSettings";
import HelpText from "../../List/HelpText";

type InfoProps = {
    id: string;
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
    setUserProjectDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>;
    userProjectDataModels: TUpsertISRProjectDataModelsInput;
    indexInfo?: TIndexState;
}

const AdditionalData = ({id, selectedItem, indexInfo, userProjectDataModels, setUserProjectDataModels}: InfoProps) => {

    const saveFieldInfo = (helpTextData: HelpTextData) => {
        setUserProjectDataModels((prevDataModels: any) => {
            const newDataModels = { ...prevDataModels };
            if (selectedItem && 'belongsToDataModel' in selectedItem && selectedItem?.belongsToDataModel) {
                const dataModelToUpdate = newDataModels.project.dataModels[indexInfo?.dataModelIndex ?? -1];
                if (dataModelToUpdate && dataModelToUpdate.data && dataModelToUpdate.data.fields[indexInfo?.fieldIndex ?? -1]) {
                    dataModelToUpdate.data.fields[indexInfo?.fieldIndex ?? -1].additionalData = helpTextData;
                }
            } else {
                const fieldToUpdate = newDataModels.project.fields[indexInfo?.fieldOutsideDataModelIndex ?? -1];
                if (fieldToUpdate && fieldToUpdate.data) {
                    fieldToUpdate.data.additionalData = helpTextData;
                }
            }
            return newDataModels;
        });
    }

    const helpText = selectedItem && 'belongsToDataModel' in selectedItem && selectedItem?.belongsToDataModel ? userProjectDataModels?.project.dataModels[indexInfo?.dataModelIndex ?? -1]?.data?.fields[indexInfo?.fieldIndex ?? -1]?.additionalData : userProjectDataModels?.project.fields[indexInfo?.fieldOutsideDataModelIndex ?? -1]?.data?.additionalData

    return(

        <Card id={id} data-testid={id} title="Additional data">
            <HelpText id={`${id}-help-text`} showDescription={true} savedHelpTextData={helpText} selectedItemId={selectedItem?.id ?? `${new Date().getTime()}`}
                      onAutoSave={(helpTextData) => saveFieldInfo(helpTextData)}
                      attachmentUrl={`${AppSettings.GMS_BACKEND_API_URL}/isr/models/${userProjectDataModels?.project?.id ?? ''}/image/upload`}
            />
        </Card>
    );
}

export default AdditionalData;